var map = {
	"./1.jpeg": 48174,
	"./2.jpeg": 77819,
	"./partners/IMD_Logo.png": 47068,
	"./partners/ciuem.png": 28385,
	"./partners/decidim.png": 88399,
	"./partners/dni.png": 87705,
	"./partners/image001.png": 87252,
	"./partners/images.png": 1430,
	"./partners/imd.png": 25904,
	"./partners/imd_logo.png": 74876,
	"./partners/masc.png": 66084
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71027;